import { useEffect } from 'react';
import { usePageContent } from './usePageContent';

const DEFAULT_SITE_NAME = 'Chaw Thinn';

/**
 * Sets document.title to "{label} - {site name}", pulling the name from the
 * CMS-editable `site` page content (with the current name as fallback).
 */
export function usePageTitle(label) {
    const { content: site } = usePageContent('site');
    const name = site?.name || DEFAULT_SITE_NAME;

    useEffect(() => {
        document.title = label ? `${label} - ${name}` : name;
    }, [label, name]);
}
